export default {
  dashboard: {
    blocks: "Blocks",
    sevenDays: "7 days",
    topTenBlockProducers: "Top 10 Block Producers",
    topTenDappsProducers: "Top 10 Dapps Producers",
    transactions: "Transactions",
    transactionVolume: "Transaction Volume"
  }
}
